import { Modal, Backdrop, Fade, TextField, Button } from "@mui/material";
import { Container, ContainerButtons, Title, Description } from "./style/ReportPopin.styled";
import PropTypes from "prop-types";
import { postReport } from "../../services/report";
import { displaySuccessFeedback, displayErrorFeedback } from "../../app/feedbackSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";

export default function ReportPopin({ isReportPopinOpen, handleReportPopinClose }) {
  const dispatch = useDispatch();
  const [reportMessage, setReportMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const { message } = await postReport({ name: "Report", desc: reportMessage });
      handleReportPopinClose();
      setReportMessage("");
      dispatch(displaySuccessFeedback({ message: message || "Your report has been sent successfully. Thanks for your help. ❤️" }));
    } catch (error) {
      dispatch(displayErrorFeedback({ message: error.message || "An error occurred while sending the report" }));
      console.error(error);
    }
  };

  return (
    <Modal
      aria-labelledby="report-modal-title"
      open={isReportPopinOpen}
      onClose={handleReportPopinClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={isReportPopinOpen}>
        <Container>
          <form onSubmit={handleSubmit}>
            <Title>Report</Title>
            <Description>A bug, a feedback or a suggestion...</Description>
            <TextField multiline rows={4} placeholder="Your message" fullWidth value={reportMessage} onChange={(e) => setReportMessage(e.target.value)} />
            <ContainerButtons>
              <Button variant="contained" color="error" onClick={handleReportPopinClose} type="button">
                Cancel
              </Button>
              <Button variant="contained" color="success" type="submit">
                Send
              </Button>
            </ContainerButtons>
          </form>
        </Container>
      </Fade>
    </Modal>
  );
}

ReportPopin.propTypes = {
  isReportPopinOpen: PropTypes.bool.isRequired,
  handleReportPopinClose: PropTypes.func.isRequired,
};
